import { useCallback, useMemo } from 'react';

import { usePlanReactivationModalStore } from '../../../stores';

export const useBulkPlanReactivationItem = (planId: string, planName: string) => {
  const planIds = usePlanReactivationModalStore((state) => state.planIds);
  const planNames = usePlanReactivationModalStore((state) => state.planNames);
  const setPlanIds = usePlanReactivationModalStore((state) => state.handleSetPlanIds);
  const setPlanNames = usePlanReactivationModalStore((state) => state.handleSetPlanNames);

  const checked = useMemo(() => planIds?.includes(planId) ?? false, [planIds, planId]);

  const handleCheckboxChange = useCallback(() => {
    if (checked) {
      setPlanIds(planIds?.filter((id: string) => id !== planId));
      setPlanNames(planNames?.filter((name: string) => name !== planName));
    } else {
      setPlanIds([...(planIds || []), planId]);
      setPlanNames([...(planNames || []), planName]);
    }
  }, [checked, planIds, planNames, planId, planName, setPlanIds, setPlanNames]);

  return {
    checked,
    handleCheckboxChange,
  };
};
